<template lang="pug">
  .modal.is-active
    .modal-background(@click="cerrarModal")
    .modal-content
      .box
        h5.title {{ config.title }}
        p {{ config.content }}
        br
        .columns
          .column
            .field
              label.label Permiso
              .control.has-icons-left
                .select.is-primary.is-rounded
                  select(v-model="permisoSelect")
                      option(v-for="p in permisos" :value="p" :key="p.id") {{ p.permisos }}
        .columns(v-show="errorMessage.length > 0")
          .column
            span.tag.is-danger
              | {{ errorMessage }}
        .columns
          .column
            .level-right
              .field.is-grouped
                p.control
                  a.button.is-rounded(:class="config.classCancel" @click="changePermisos(false)")
                    | {{ config.textCancel }}
                p.control
                  a.button.is-rounded(:class="config.classOk" @click="changePermisos(true)")
                    | {{ config.textOk }}
</template>

<script>
  export default {
    name: 'ModalPermisos',
    props: {
      config: {
        type: Object,
        default: ()=> {}
      },
      permisos: {
        type: Array,
        default: []
      },
      tipo: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        permisoSelect: {},
        errorMessage: '',
      }
    },
    watch: {
      permisoSelect() {
        if (Object.keys(this.permisoSelect).length > 0) {
          this.errorMessage = ''
        }
      }
    },
    methods: {
      cerrarModal () {
        const myObj = {
          action: false,
          type: null,
          item: null
        }
        this.$emit('padre:select', myObj)
      },
      changePermisos (permiso) {
        if (!permiso) {
          this.cerrarModal()
          return
        }
        this.errorMessage = ''
        if (Object.keys(this.permisoSelect).length > 0) {
          const myObj = {
            action: permiso,
            type: this.tipo,
            item: this.permisoSelect
          }
          this.permisoSelect = {}
          this.$emit('padre:select', myObj)
        } else {
          this.errorMessage = 'Debe Seleccionar un permiso.'
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/usuarios_Componentes/componentes/ModalCambiarPermisos.vue